<template>
    <v-list-item-content>
        <v-list-item-title>
            <TypIcon :address-record="item" />
            <LegalTypeIcon :address-record="item" />
            <KpIcon :icon-cls="item.status_icon" :color="item.status_icon_color" :title="item.humanReadableStatus" />
            <KpIcon v-if="item.is_imported" icon-cls="newregistrations" color="primary" :title="$t('imported')" />
            <KpIcon v-else icon-cls="ownnotimported" color="primary" title="Eigene (nicht importiert)" />
            <span>{{ item.displayTitle || item.title }}</span>
            <span v-if="item.city">, {{ item.city }}</span>
            &nbsp;
            <span v-if="userIsStaff() && item.event_organizer">({{ item.event_organizer }})</span>
        </v-list-item-title>
    </v-list-item-content>
</template>

<script>
/**
 * This component is an entry (item) of an address selection list, used
 * as combo entry e.g. in an autocomplete component's `item` slot.
 *
 * It renders the address (or location, or event organizer) entry
 * with additional infos like a status icon.
 *
 * - item: the Address, Location or EventOrganizer record
 */
import { userIsStaff } from '@/helpers/auth';
import LegalTypeIcon from './LegalTypeIcon.vue';
import TypIcon from './TypIcon.vue';

export default {
    name: 'AddressComboListItem',
    components: { LegalTypeIcon, TypIcon },
    props: {
        item: {
            type: Object,
            required: true,
        },
    },
    created() {
        this.userIsStaff = userIsStaff;
    },
};
</script>
